/**
 * Public download URLs for the AOTV Slide Control desktop apps.
 *
 * Both are served by the Worker's release proxy (`worker/src/routes/
 * releases.ts`), which pulls the asset out of the private repo's latest
 * release with a fine-grained PAT. The filenames are fixed — release.sh and
 * release.ps1 always upload under the same names — so these URLs never need
 * bumping for a new version.
 */
export const SLIDE_CONTROL_DOWNLOADS = {
  windows: 'https://call.aotv.co.uk/download/AOTV-Slide-Control-Windows.zip',
  mac: 'https://call.aotv.co.uk/download/AOTV-Slide-Control.zip',
} as const;

/** Shareable install page — public, so freelancers don't need a login. */
export const SLIDE_CONTROL_DOWNLOAD_PAGE = 'https://call.aotv.co.uk/downloads';

export type SlideControlPlatform = 'windows' | 'mac';

/** Best guess at the visitor's platform, so we can lead with the right card. */
export function detectPlatform(): SlideControlPlatform {
  if (typeof navigator === 'undefined') return 'windows';
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('mac') && !ua.includes('windows') ? 'mac' : 'windows';
}
